import Price from '~/utils/Price/Price';

export class ProductComputedPrice {
	constructor(
		public readonly type: string,
		public readonly price: Price,
		public readonly description: string,
		public readonly selected: boolean
	) {}
}
